"use client";

import { Container } from "@chakra-ui/react";
import { HELP_CENTER_IDS } from "../_constants/help-center.ids";
import { SectionHeader } from "./SectionHeader";

interface HelpCenterPageFrameProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
}

export function HelpCenterPageFrame({
  children,
  title,
  subtitle,
}: HelpCenterPageFrameProps) {
  return (
    <>
      <SectionHeader title={title} subtitle={subtitle} />
      <Container
        pb={{ base: 8, md: 14 }}
        pt={{ base: "88px", md: "3.25rem" }}
        id={HELP_CENTER_IDS.pageFrame.body}
        maxW="1000px"
        px={{ base: 5, md: 3 }}
      >
        {children}
      </Container>
    </>
  );
}
